import React from 'react';

class Footer extends React.Component {

    render() {
        return (
            <p>Desenvolvido por <a href="http://www.setrem.com.br" target="_blank" rel="noopener noreferrer">SETREM</a>, {new Date().getFullYear()}.</p>
        );
    }
}

export default Footer;